export default __webpack_public_path__ + "static/media/GIF-IXELLES.98883f97.gif";